import React from 'react';
import { ClipboardList, ExternalLink } from 'lucide-react';
import { Card } from '../ui';

const safeUrl = (v) => (/^https?:\/\//i.test(v) ? v : null);
const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '');

const Answer = ({ a }) => {
  const url = a.is_url && safeUrl(a.value);
  return (
    <div className={a.value.length > 60 ? 'sm:col-span-2' : ''} data-testid={`enrollment-answer-${a.key}`}>
      <p className="text-[11px] font-semibold uppercase tracking-widest text-slate-400">{a.label}</p>
      {url ? <a href={url} target="_blank" rel="noopener noreferrer" className="text-sm text-teal-700 hover:underline inline-flex items-center gap-1 break-all mt-0.5">{a.value}<ExternalLink className="w-3 h-3 shrink-0" /></a>
        : <p className="text-sm text-[#0b1f4d] mt-0.5 whitespace-pre-line">{a.value}</p>}
    </div>
  );
};

export const EnrollmentAnswers = ({ forms }) => (
  <Card data-testid="admin-enrollment-answers">
    <div className="flex items-center gap-2 mb-1"><ClipboardList className="w-4 h-4 text-teal-600" /><p className="font-outfit font-semibold text-[#0b1f4d]">Enrollment form answers</p></div>
    <p className="text-xs text-slate-500 mb-4">What the student told us when they paid. Review before the kickoff call.</p>
    {!forms.length && <p className="text-sm text-slate-500" data-testid="admin-enrollment-answers-empty">No paid enrollment form on the website for this email yet.</p>}
    <div className="space-y-5">
      {forms.map((f) => (
        <div key={f.id} className="rounded-xl border border-slate-200 p-4" data-testid={`enrollment-form-${f.id}`}>
          <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
            <p className="text-sm font-semibold text-[#0b1f4d]">{f.plan}</p>
            <span className="text-xs text-slate-500">Paid {fmt(f.paid_at)}</span>
          </div>
          <div className="grid sm:grid-cols-2 gap-x-6 gap-y-3">{f.answers.map((a) => <Answer key={a.key} a={a} />)}</div>
        </div>
      ))}
    </div>
  </Card>
);
